import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LocalizationDecimalPipe } from '@sb/library/localization';
import { ConvertBRToNewLinePipe } from './conversion/convert-br-to-newline.pipe';
import { ConvertNewLineToBRPipe } from './conversion/convert-newline-to-br.pipe';
import { ConvertToHtmlPipe } from './conversion/convert-to-html.pipe';
import { FormatFilenamePipe } from './file/format-filename.pipe';
import { FormatFilesizePipe } from './file/format-filesize.pipe';
import { FormatDaysPipe } from './format-duration/format-days.pipe';
import { FormatHoursPipe } from './format-duration/format-hours.pipe';
import { FormatMinutesPipe } from './format-duration/format-minutes.pipe';
import { FormatSecondsPipe } from './format-duration/format-seconds.pipe';
import { LazyLoadComponent } from './lazy-load/lazy-load.component';
import { ImageResizeDirective } from './resize/resize-image.directive';
import { TrustHtmlPipe } from './sanitization/trust-html.pipe';
import { TrustUrlPipe } from './sanitization/trust-url.pipe';
import { ClickedOutsideDirective } from './click-outside/click-outside.directive';
import { LessonCountFromMinutesPipe } from './format-duration/lesson-count-from-minutes.pipe';

@NgModule({
    declarations: [
        TrustHtmlPipe,
        TrustUrlPipe,
        LazyLoadComponent,
        FormatSecondsPipe,
        FormatMinutesPipe,
        FormatHoursPipe,
        FormatDaysPipe,
        FormatFilenamePipe,
        FormatFilesizePipe,
        ConvertToHtmlPipe,
        ConvertBRToNewLinePipe,
        ConvertNewLineToBRPipe,
        ImageResizeDirective,
        ClickedOutsideDirective,
        LessonCountFromMinutesPipe
    ],
    providers: [LocalizationDecimalPipe],
    imports: [
        CommonModule
    ],
    exports: [
        TrustHtmlPipe,
        TrustUrlPipe,
        LazyLoadComponent,
        FormatSecondsPipe,
        FormatMinutesPipe,
        FormatHoursPipe,
        FormatDaysPipe,
        FormatFilenamePipe,
        FormatFilesizePipe,
        ConvertToHtmlPipe,
        ConvertNewLineToBRPipe,
        ConvertBRToNewLinePipe,
        ImageResizeDirective,
        ClickedOutsideDirective,
        LessonCountFromMinutesPipe
    ]
})
export class UtilityModule { }
